import React from "react";

interface HearthstoneIconProps {
  size?: number;
  className?: string;
  variant?: "default" | "mono-light" | "mono-dark" | "brand";
}

const HearthstoneIcon: React.FC<HearthstoneIconProps> = ({
  size = 32,
  className = "",
  variant = "default",
}) => {
  // default/brand follow the theme's primary token (lighter terra cotta in
  // dark mode) instead of a fixed hex; mono variants stay fixed by design.
  const config = {
    default: { fill: "currentColor", colorClass: "text-primary" },
    "mono-light": { fill: "#EDEBE8", colorClass: "" },
    "mono-dark": { fill: "#1A1A18", colorClass: "" },
    brand: { fill: "currentColor", colorClass: "text-primary" },
  };

  const { fill, colorClass } = config[variant];

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${colorClass} ${className}`.trim()}
      aria-label="Alfie"
      role="img"
    >
      {/* Central sphere */}
      <circle cx="32" cy="32" r="6" fill={fill} />
      {/* Inner ring of spheres */}
      <circle cx="43" cy="32" r="4" fill={fill} opacity="0.75" />
      <circle cx="37.5" cy="22.46" r="4" fill={fill} opacity="0.75" />
      <circle cx="26.5" cy="22.46" r="4" fill={fill} opacity="0.75" />
      <circle cx="21" cy="32" r="4" fill={fill} opacity="0.75" />
      <circle cx="26.5" cy="41.54" r="4" fill={fill} opacity="0.75" />
      <circle cx="37.5" cy="41.54" r="4" fill={fill} opacity="0.75" />
      {/* Outer ring — offset for organic feel */}
      <circle cx="49.32" cy="22" r="3" fill={fill} opacity="0.5" />
      <circle cx="32" cy="12" r="3" fill={fill} opacity="0.5" />
      <circle cx="14.68" cy="22" r="3" fill={fill} opacity="0.5" />
      <circle cx="14.68" cy="42" r="3" fill={fill} opacity="0.5" />
      <circle cx="32" cy="52" r="3" fill={fill} opacity="0.5" />
      <circle cx="49.32" cy="42" r="3" fill={fill} opacity="0.5" />
    </svg>
  );
};

export default HearthstoneIcon;
